import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data/services";

export const NextServices = ({ current }) => {
  const others = SERVICES.filter((s) => s.slug !== current);
  return (
    <section className="border-t border-white/10 bg-[var(--ink)]" data-testid="next-services">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <p className="overline py-8 text-[var(--signal)]">Other services</p>
        {others.map((s) => (
          <Link key={s.slug} to={`/services/${s.slug}`} data-testid={`next-service-${s.slug}`}
            className="group flex items-center justify-between gap-6 border-t border-white/10 py-6 transition-colors hover:text-[var(--signal)]">
            <span className="flex items-baseline gap-5">
              <span className="font-mono text-xs text-[var(--bone-2)]">{s.code}</span>
              <span className="font-display text-3xl font-extrabold uppercase transition-transform duration-500 group-hover:translate-x-3 md:text-5xl">{s.title}</span>
            </span>
            <ArrowUpRight className="h-6 w-6 shrink-0 transition-transform duration-500 group-hover:rotate-45" />
          </Link>
        ))}
      </div>
    </section>
  );
};
